module.exports = "data:image/png;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiMzg3NGU4ZGFlN2NjN2IxZGI0Yjc3ZTkyMTZkZGIxNzIucG5nIjs="